<script setup lang="ts">
import ActivityLog from './components/ActivityLog.vue';
import ActivityAttendance from './components/ActivityAttendance.vue';
import { PERMISSIONS } from '@/enum';
import { can } from '@/composables';
</script>

<template>
  <ActivityLog v-if="can([PERMISSIONS.PERSON_LOGS_INDEX])" />
  <ActivityAttendance />
</template>
